import type GroupedTag from '@alltrails/types/GroupedTag';
import type Tag from '@alltrails/types/Tag';

// Tag group IDs corresponding to grouped tag categories from the API
const fees = 4;
const trailInfo = 3;
const obstacles = 5;
const features = 2;
const activities = 1;

// Priority order: Fees, Trail Info, Obstacles, Features, Activities
export const tagGroupPriorityOrder = [fees, trailInfo, obstacles, features, activities];

const tagLimits = new Map<number, number>([
  [fees, 2],
  [trailInfo, 4],
  [obstacles, 2],
  [features, 2],
  [activities, 0]
]);

const getSortedGroupedTags = (groupedTags: GroupedTag[], maxTags: number): Tag[] => {
  const sortedGroups = groupedTags.filter(group => group.tags.length > 0).sort((a, b) => tagGroupPriorityOrder.indexOf(a.id) - tagGroupPriorityOrder.indexOf(b.id));
  const result: Tag[] = [];
  let remainingSpace = maxTags;

  for (const group of sortedGroups) {
    const limit = tagLimits.get(group.id) ?? 0;
    const tagsToAdd = limit === 0 ? group.tags.slice(0, remainingSpace) : group.tags.slice(0, Math.min(limit, remainingSpace));
    result.push(...tagsToAdd);
    remainingSpace -= tagsToAdd.length;
    if (remainingSpace <= 0) break;
  }

  return result;
};

export default getSortedGroupedTags;
